/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Port
 */
export interface Port {
    /**
     * The name of the port
     * @type {string}
     * @memberof Port
     */
    name?: string;
    /**
     * The code of the port
     * @type {string}
     * @memberof Port
     */
    code?: string;
    /**
     * The country code of the port
     * @type {string}
     * @memberof Port
     */
    countryCode?: string;
    /**
     * The country name of the port
     * @type {string}
     * @memberof Port
     */
    countryName?: string;
}

/**
 * Check if a given object implements the Port interface.
 */
export function instanceOfPort(value: object): value is Port {
    return true;
}

export function PortFromJSON(json: any): Port {
    return PortFromJSONTyped(json, false);
}

export function PortFromJSONTyped(json: any, ignoreDiscriminator: boolean): Port {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'code': json['code'] == null ? undefined : json['code'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'countryName': json['countryName'] == null ? undefined : json['countryName'],
    };
}

export function PortToJSON(json: any): Port {
    return PortToJSONTyped(json, false);
}

export function PortToJSONTyped(value?: Port | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'code': value['code'],
        'countryCode': value['countryCode'],
        'countryName': value['countryName'],
    };
}

